import type { paths } from '@pba/types-openapi-node';
import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';
import type { MedicalGroupDetailDataObject } from 'models/service';

type MedicalGroupDetailRequestParams = paths['/medical-groups/{id}']['get']['parameters']['path'];

export const getMedicalGroupDetail = async ({
  routeParams: { id },
}: RouteParamsRequest<MedicalGroupDetailRequestParams>) =>
  nodeApiClient.get<MedicalGroupDetailDataObject, ApiClientResponse<MedicalGroupDetailDataObject>>(
    nodeApiRoutes.medicalGroups.detail(id),
  );
